import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { connect } from "react-redux"
import * as React from "react"
import { Col, Row, Tabs } from "antd"
import { Router } from "../../../../server/router"
import { GLOBAL_FILTER_IDENTIFIER } from "../../../filters/reducer"
import { specialPricingReportAgendaMounted } from "./actions"
import SpecialPricingLogReportTable from "./SpecialPricingLogReportTable"
import ReportHeadingPanel from "../components/ReportHeadingPanel"
import {
    getDataForSpecialPricingByEmployeeTable,
    getDataForSpecialPricingLogsTable,
    getDataForSpecialPricingSummaryTable,
} from "./selectors"
import type { SpecialPricingLogReportItem, SpecialPricingSummaryReportItem } from "../../../../graphql/types"
import SpecialPricingSummaryReportTable from "./SpecialPricingSummaryReportTable"
import { expandAllIds } from "../../../../utils/general"
import { DateRangePickerDataWrapper } from "../components/DateRangePickerDataWrapper"

type Props = {
    tab: Maybe<string>
    specialPricingLogData: SpecialPricingLogReportItem[]
    specialPricingSummaryData: SpecialPricingSummaryReportItem[]
    specialPricingByEmployeeData: SpecialPricingSummaryReportItem[]
    onLoaded: () => void
}

export const SpecialPricingReportTabsEnum = {
    Summary: "summary",
    Employee: "employee",
    Log: "log",
}

export type SpecialPricingReportTabs = (typeof SpecialPricingReportTabsEnum)[keyof typeof SpecialPricingReportTabsEnum]

class SpecialPricingReportTabsContainer extends React.PureComponent<Props> {
    componentDidMount() {
        this.props.onLoaded()
    }

    handleTabClicked = (key: string) => {
        Router.push(`/reports/specialPricing/${key}`)
    }

    render() {
        return (
            <div id="sales-by-report-tabs">
                <Row>
                    <Col span={24}>
                        <Tabs
                            onTabClick={this.handleTabClicked}
                            className="sales-by-report-tabs"
                            // @ts-expect-error
                            activeKey={this.props.tab}>
                            <Tabs.TabPane tab="Summary" key="summary">
                                <ReportHeadingPanel
                                    showReportTitle={false}
                                    identifier="specialPricingSummary"
                                    headerText="Summary"
                                    showOrderStatusFilter={false}
                                    showOrderSourceFilter={false}
                                    haveData={true}
                                    showSearchFilter={false}
                                />
                                <SpecialPricingSummaryReportTable
                                    expandedRowsIds={expandAllIds(this.props.specialPricingSummaryData)}
                                    showLoading={false}
                                    data={this.props.specialPricingSummaryData}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab="Employee" key="employee">
                                <ReportHeadingPanel
                                    showReportTitle={false}
                                    identifier="specialPricingSummary"
                                    headerText="Employee"
                                    showOrderStatusFilter={false}
                                    showOrderSourceFilter={false}
                                    haveData={true}
                                    showSearchFilter={false}
                                />
                                <SpecialPricingSummaryReportTable
                                    expandedRowsIds={expandAllIds(this.props.specialPricingByEmployeeData)}
                                    showLoading={false}
                                    data={this.props.specialPricingByEmployeeData}
                                />
                            </Tabs.TabPane>

                            <Tabs.TabPane tab="Log" key="log">
                                <ReportHeadingPanel
                                    showReportTitle={false}
                                    identifier="specialPricingLog"
                                    headerText="Logs"
                                    showOrderStatusFilter={false}
                                    showOrderSourceFilter={false}
                                    haveData={true}
                                    showSearchFilter={false}
                                />
                                <SpecialPricingLogReportTable
                                    data={this.props.specialPricingLogData}
                                    reportIdentifier="specialPricingLog"
                                />
                            </Tabs.TabPane>
                        </Tabs>
                    </Col>
                    <div
                        style={{
                            right: "16px",
                            position: "absolute",
                            top: "6px",
                        }}>
                        <Row
                            type="flex"
                            justify="end"
                            style={{
                                flexWrap: "nowrap",
                            }}>
                            <DateRangePickerDataWrapper identifier={GLOBAL_FILTER_IDENTIFIER} />
                        </Row>
                    </div>
                </Row>
                <style jsx={true} global={true}>
                    {`
                        .sales-by-report-tabs .ant-tabs-bar {
                            margin-bottom: 0px;
                        }

                        .sales-by-report-tabs .ant-tabs-tab,
                        .sales-by-report-tabs .ant-tabs-tab-active {
                            font-size: 1rem;
                            font-weight: bold !important;
                        }
                    `}
                </style>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    specialPricingLogData: getDataForSpecialPricingLogsTable(state),
    specialPricingSummaryData: getDataForSpecialPricingSummaryTable(state),
    specialPricingByEmployeeData: getDataForSpecialPricingByEmployeeTable(state),
})

const mapDispatchToProps = {
    onLoaded: specialPricingReportAgendaMounted,
}
export default connect<any, any, any>(mapStateToProps, mapDispatchToProps)(SpecialPricingReportTabsContainer)
